
import {removeToken, setToken} from "@/utils/token"
import {showToast} from "@/utils/toast";
import {getAccountDetail} from "@/api/login";
// import {login, changeAdminPassword, getAdminInfo, updateAdminInfo, currentUser} from "@/api/login";
// 处理路由
// roler:supermanager(超级管理员，暂时没做)/commanager（管理员admin）/storemanager（门店agent）
const state = {
    login: false, // 是否登录
    userInfo: {},//用户信息
    auth: null,// 权限相关信息
}
const getters = {
    getLoginState: (state) => state.login,// 获取登录状态
    getUserInfo: (state) => state.userInfo,// 获取用户信息
}
const mutations = {
    // 登录成功
    login: (state, payload) => {
        state.login = payload
    },
    userInfo: (state, payload) => {
        state.userInfo = {...state.userInfo, ...payload}
    },
    loginOut: (state) => {
        // state.login = payload === 'undefined' ? false : !payload
        state.login = false // 登出
        state.userInfo = false
        removeToken() // 消除token
        // state.menulist = [] // 清空菜单
        // window.location.reload()
    },
}
const actions = {
    loginOut(context) { // 退出
        context.commit("loginOut", true)
        context.commit("userInfo", {})
    },
//    获取当前账户信息
    async getUserInfo(context,data){
        const res = await getAccountDetail(data)
        if(res.err_code ===0){
            context.commit("userInfo", res.data)
        }
        return Promise.resolve(res)
    }

}
const modules = {}
export default {
    namespaced: true,
    state() {
        return state
    },
    getters,
    mutations,
    actions,
    modules
}

